import React, {
    createContext,
    memo,
    useContext,
    useMemo,
} from "react";
import PropTypes from "prop-types";

const WorkflowinstanceContext = createContext("global.workflowinstance");

export const WorkflowinstanceContextProvider = memo(
    ({ workflowinstance, children }) => {
        return (
            <WorkflowinstanceContext.Provider value={workflowinstance}>
                {children}
            </WorkflowinstanceContext.Provider>
        );
    }
);

WorkflowinstanceContextProvider.defaultProps = {
    children: null,
    workflowinstance: undefined,
};

WorkflowinstanceContextProvider.propTypes = {
    children: PropTypes.node,
    workflowinstance: PropTypes.string
};

WorkflowinstanceContextProvider.displayName = "WorkflowinstanceContextProvider";

export const useWorkflowinstanceContext = () => {
    const workflowinstance = useContext(WorkflowinstanceContext);
    return useMemo(() => ({ workflowinstance }), [workflowinstance]);
};

export default WorkflowinstanceContextProvider;
